import * as d3 from 'd3'
export default {
  methods: {

    draw_DonutChart() {

      this.canvasForms
      .append('g')
      .attr('id', `DONUT_GROUP_${this.localId}`)
      .attr('transform', `translate(${this.donut.cx},${this.donut.cy})`)
      .call(this.event_Link, this.donut)

      let bgGroup = d3.select(`#DONUT_GROUP_${this.localId}`)
      this.rawData.forEach((d,i)=> {
        let arc = d3.arc()
        .outerRadius(d.ra)
        .innerRadius(d.ra - d.stroke)
        .startAngle(this.angle.start * Math.PI / 180)
        .endAngle(this.angle.end * Math.PI / 180)

        bgGroup
        .append('path')
        .attr('d', arc)
        .attr('fill', d.bgColor)
      })
      

      let frontGroup = d3.select(`#DONUT_GROUP_${this.localId}`)
      .append('g')
      
      let arc = d3.arc()
      .outerRadius(d => d.ra)
      .innerRadius(d => d.ra - d.stroke)
      .startAngle(this.angle.start * Math.PI / 180)
      .endAngle(d => d.endAngle || this.angle.start * Math.PI / 180)

      frontGroup
      .selectAll('path')
      .data(this.rawData)
      .enter()
      .append('path')
      .attr('d', arc)
      .attr('opacity', (d) => d.opacity)
      .attr('fill', (d)  => d.color)
      .transition().duration(750)
      .attrTween('d', d => {
        let endAngle_ = ( ((this.angle.size * (d.PROG/100)) + this.angle.start) * Math.PI / 180)
        let interpolate = d3.interpolate(this.angle.start * Math.PI / 180, endAngle_)
        return function(t) {
          d.endAngle = interpolate(t)
          return arc(d)
        }
      })

      let max = Math.max(...this.donut.styles.map(item => item.radius))
      bgGroup 
      .append('circle')
      .attr('cx', 0).attr('cy', 0)
      .attr('r', max).attr('opacity', .0)
      .attr('fill', `#bcbcbc`)

      // Shadow
      if(this.icon.display == 'Y') return
      
      this.canvasForms 
      .append('ellipse')
      .attr('cx', this.donut.cx).attr('cy', this.donut.cy + max)
      .attr('rx', max).attr('ry', max * 0.1).attr('opacity', .75)
      .attr('fill', `url(#SHADOW_${this.localId})`)

      d3.select(`#DONUT_GROUP_${this.localId}`).moveToFront()
    },

  }
}